/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type TopBar_user = {
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_user" | "CartNav_user" | "Notifications_user">;
    readonly " $refType": "TopBar_user";
};
export type TopBar_user$data = TopBar_user;
export type TopBar_user$key = {
    readonly " $data"?: TopBar_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TopBar_user">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isClient"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopBar_user",
    "selections": [
        {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AccountNav_user"
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CartNav_user"
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Notifications_user"
                }
            ]
        }
    ],
    "type": "User",
    "abstractKey": null
} as any;
(node as any).hash = '8b9d906e238b5be75ac5e5f3ac98ae6e';
export default node;
